import { useQuery } from "@tanstack/react-query";

import CustomFieldService from "services/CustomField";
import CustomFieldGroupsService from "services/CustomFieldGroups";

export const useCustomFieldConfigs = modelType =>
  useQuery({
    queryKey: ["custom-field-configs", modelType],
    queryFn: () => CustomFieldService.getCustomFieldConfigsForModel(modelType),
    meta: { errorMessage: "Could not load custom fields" },
  });

export const useCustomFieldGroups = modelType =>
  useQuery({
    queryKey: ["custom-field-groups", modelType],
    queryFn: () =>
      CustomFieldGroupsService.getCustomFieldGroupsForModelType(modelType),
    meta: { errorMessage: "Could not load custom field groups" },
  });
